<template>
  <div class="component">
    <transition enter-active-class="fade-in-up">
      <div class="container px-xs-sm-2" v-if="inview">
        <div class="row">
          <div class="col-md-6">
            <figure>
              <img class="img-fluid" v-bind:src="acf.image" />
            </figure>
          </div>
          <div class="col-md-6">
            <div class="headings pt-4 pt-md-0">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <div class="title">
                <h5>{{ acf.name }}</h5>
              </div>
              <h1 v-html="acf.headline"></h1>
              <a
                v-if="acf.cta.text"
                v-bind:href="acf.cta.href"
                class="btn"
                v-bind:target="acf.cta.target[0]"
                v-bind:class="{
                  'cta-plain text-red icon right-arrow':
                    acf.cta.style === 'text',
                  'cta-pill filled-red icon right-arrow':
                    acf.cta.style === 'pill',
                }"
                >{{ acf.cta.text }}</a
              >
            </div>
          </div>
        </div>
        <div class="row content offset-xl-1">
          <div class="col-md-4 mb-4 mb-md-0" v-for="item in acf.solutions">
            <eyebrow-icon
              v-if="item.eyebrowicon"
              v-bind:eyebrowicon="item.eyebrowicon"
            ></eyebrow-icon>
            <h5 v-html="item.title"></h5>
            <p class="d-none d-md-block" v-html="item.description"></p>
            <a
              v-bind:href="item.href"
              class="btn"
              v-bind:target="item.target[0]"
              v-bind:class="{
                'cta-plain text-red icon right-arrow': item.style === 'text',
                'cta-pill filled-red icon right-arrow': item.style === 'pill',
              }"
              >{{ item.cta }}</a
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import inview from "../../mixins/inview";

export default {
  name: "saas-solutions",
  props: ["acf"],
  mixins: [inview],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.title {
  margin-bottom: 0.5rem;
  @extend %body-normal-bold;
}

h1 {
  margin-bottom: 1.75rem;
  transform: translateX(-5px);

  span {
    color: $cc-resmed-pulse-blue;
  }
}

h5 {
  position: relative;
  margin-bottom: 0.25rem;

  &:before {
    content: "";
    position: absolute;
    top: -1rem;
    left: 0;
    width: 1.25rem;
    height: 3px;
    background-color: $cc-resmed-black;
  }

  @media (min-width: 768px) {
    margin-bottom: 0.75rem;
  }
}

figure {
  padding: 0 0 2rem 0;

  @media (min-width: 768px) {
    padding: 0 4rem 4rem 0;
  }

  @media (min-width: 1200px) {
    padding: 0 4rem 4rem 2rem;
  }
}

.content {
  padding-top: 3rem;

  @media (min-width: 768px) {
    .btn {
      position: absolute;
      bottom: 0;
    }
  }

  @media (min-width: 1200px) {
    padding-top: 1rem;
  }

  h5 {
    &:before {
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    }
  }

  p {
    margin: 0;
    padding-bottom: 2.25rem;

    @media (min-width: 992px) {
      padding: 0 2rem 2.25rem 0;
    }

    @media (min-width: 1200px) {
      padding: 0 4rem 2.25rem 0;
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

// --> /deep/ no longer works
.saas-solutions .headings {
  h1 {
    margin-bottom: 1.75rem;

    span {
      color: $cc-resmed-pulse-blue;
    }
  }
}
</style>